<template>


<!-- ai dashbord -->
 <div class="container-fluid py-4">

    <ul class="nav nav-tabs mb-3">
      <li class="nav-item">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'dashboard' }"
          @click="activeTab = 'dashboard'"
        >
          {{ $t('dashboard.dashboardAI') }}
        </button>
      </li>

      <li class="nav-item">
        <button
          class="nav-link"
          :class="{ active: activeTab === 'chat' }"
          @click="activeTab = 'chat'"
        >
          {{ $t('dashboard.aiChat') }}
        </button>
      </li>
    </ul>

      <div v-if="activeTab === 'dashboard'">
      <DashboardAi />
    </div>

    <div v-else-if="activeTab === 'chat'">
      <AiChat />
    </div>
 </div>
  <div class="container">
    
    <span></span>
    <p>{{ $t('welcome') }}</p>

    <!-- KPI row -->
    <div class="row g-3 mb-4">
      <div class="col-md-3">
        <div class="card text-white bg-primary">
          <div class="card-body">
            <h6 class="card-subtitle mb-2">{{ $t('dashboard.salesToday') }}</h6>
            <h3>{{ currency(data.todaySales) }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-white bg-success">
          <div class="card-body">
            <h6 class="card-subtitle mb-2">{{ $t('dashboard.stockValue') }}</h6>
            <h3>{{ currency(data.stockValue) }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-white bg-info">
          <div class="card-body">
            <h6 class="card-subtitle mb-2">{{ $t('dashboard.pendingPO') }}</h6>
            <h3>{{ data.pendingPO }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-white bg-warning">
          <div class="card-body">
            <h6 class="card-subtitle mb-2">{{ $t('dashboard.pendingSO') }}</h6>
            <h3>{{ data.pendingSO }}</h3>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card text-white bg-secondary">
          <div class="card-body">
            <h6 class="card-subtitle mb-2">{{ $t('dashboard.cashOnHand') }}</h6>
            <h3>{{ currency(data.cashOnHand) }}</h3>
          </div>
        </div>
      </div>
    </div>

    <!-- Stock balance table -->
    <div class="row mb-4">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header d-flex justify-content-between">
            <span>{{ $t('dashboard.stockBalance') }}</span>
            <button class="btn btn-sm btn-outline-secondary" @click="exportCSV(data.stockItems, 'stock-balance.csv')">{{ $t('dashboard.exportCSV') }}</button>
          </div>
          <div class="card-body p-0">
            <table class="table table-sm table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>{{ $t('dashboard.sku') }}</th>
                  <th>{{ $t('dashboard.product') }}</th>
                  <th>{{ $t('dashboard.warehouse') }}</th>
                  <th>{{ $t('dashboard.qty') }}</th>
                  <th>{{ $t('dashboard.value') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in data.stockItems" :key="`${p.id}-${p.warehouse}`">
                  <td>{{ p.sku }}</td>
                  <td>{{ p.name }}</td>
                  <td>{{ p.warehouse }}</td>
                  <td>{{ p.quantity }}</td>
                  <td>{{ currency(p.value) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Low stock -->
      <div class="col-md-4">
        <div class="card">
          <div class="card-header">{{ $t('dashboard.lowStock') }}</div>
          <div class="card-body p-0">
            <table class="table table-sm table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>{{ $t('dashboard.sku') }}</th>
                  <th>{{ $t('dashboard.qty') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="p in data.lowStock" :key="`${p.id}-${p.warehouse}`">
                  <td>{{ p.sku }}</td>
                  <td><span class="badge bg-warning">{{ p.quantity }}</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Top customers / suppliers -->
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">{{ $t('dashboard.topCustomers') }}</div>
          <div class="card-body p-0">
            <table class="table table-sm table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>{{ $t('dashboard.customer') }}</th>
                  <th>{{ $t('dashboard.lifetime') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="c in data.topCustomers" :key="c.id">
                  <td>{{ c.name }}</td>
                  <td>{{ currency(c.lifetime) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">{{ $t('dashboard.topSuppliers') }}</div>
          <div class="card-body p-0">
            <table class="table table-sm table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>{{ $t('dashboard.supplier') }}</th>
                  <th>{{ $t('dashboard.spend') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="s in data.topSuppliers" :key="s.id">
                  <td>{{ s.name }}</td>
                  <td>{{ currency(s.spend) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Recent movements -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between">
            <span>{{ $t('dashboard.recentMovements') }}</span>
            <button class="btn btn-sm btn-outline-secondary" @click="exportCSV(data.movements, 'movements.csv')">{{ $t('dashboard.exportCSV') }}</button>
          </div>
          <div class="card-body p-0">
            <table class="table table-sm table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>{{ $t('dashboard.date') }}</th>
                  <th>{{ $t('dashboard.product') }}</th>
                  <th>{{ $t('dashboard.warehouse') }}</th>
                  <th>{{ $t('dashboard.type') }}</th>
                  <th>{{ $t('dashboard.qty') }}</th>
                  <th>{{ $t('dashboard.cost') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="m in data.movements" :key="m.id">
                  <td>{{ shortDate(m.created_at) }}</td>
                  <td>{{ m.product_name }}</td>
                  <td>{{ m.warehouse_name }}</td>
                  <td>{{ m.transaction_type }}</td>
                  <td>{{ m.quantity }}</td>
                  <td>{{ currency(m.unit_cost * m.quantity) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  


</template>

<script setup>
import { ref, onMounted } from 'vue'
import api from '../api/axios'
// import { company } from '../api/axios'
import DashboardAi from './DashboardAi.vue'
import AiChat from './AiChat.vue'
// import { StockLedgerSerializer } from '@/api/serializers'   // only if you re-use it, else drop

/* ---------- reactive ---------- */
const data = ref({
  todaySales: 0,
  stockValue: 0,
  stockItems: [],
  lowStock: [],
  pendingPO: 0,
  pendingSO: 0,
  movements: [],
  topCustomers: [],
  topSuppliers: [],
  cashOnHand: 0
})

const activeTab = ref('dashboard')

/* ---------- helpers ---------- */
const currency = (v) => new Intl.NumberFormat('en-ET', { style: 'currency', currency: 'ETB' }).format(v)
const shortDate = (d) => new Date(d).toLocaleDateString()

/* ---------- life-cycle ---------- */
onMounted(async () => {
  const res = await api.get('/dashboard/full/')
  data.value = res.data
})

/* ---------- utils ---------- */
function exportCSV (arr, filename) {
  if (!arr.length) return
  const header = Object.keys(arr[0]).join(',')
  const rows = arr.map(r => Object.values(r).join(','))
  const blob = new Blob([[header, ...rows].join('\n')], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url; a.download = filename; a.click()
  URL.revokeObjectURL(url)
}
</script>

<style scoped>
/* ---------- cards ---------- */
.card {
  transition: box-shadow 0.2s;
}

.card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

/* ---------- KPI cards ---------- */
.row.g-3 > [class*="col-"] {
  margin-bottom: 1rem;
}

/* ---------- tables ---------- */


</style>